import API from "@/services/api/api.service";
import { RouteLocationNormalized } from "vue-router";

export const roleResolver = async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    try {
        const res = await API.getRole(to.params.id as string);
        to.meta.role = res.data.data;
    } catch(error) {
        console.error('ROLE_RESOLVER_ERROR');
        return { name: 'SystemRoles' };
    }
}